import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingLineChartWidget } from '../../line-chart-widget/line-chart-widget.component';
import { EveReportingWidgetDataSourceType } from '../../widget-menu-settings/widget-datasource/widget-datasource.component';





@Component({
  selector: 'line-chart-widget-menu-settings',
  templateUrl: 'line-chart-widget-menu-settings.component.html',
  styleUrls: ['./line-chart-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class LineChartWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingLineChartWidget = null;

  constructor(

  ) {


  }
  ngOnInit(): void {

    //TODO: this isnt right
    if (this.widget.dataSource?.type != EveReportingWidgetDataSourceType.EveMultiChart) this.widget.dataSource = {
      type: EveReportingWidgetDataSourceType.EveMultiChart
    };
  }


}



